import gql from 'graphql-tag';

const FRAGMENTS = gql`
  fragment Group on groups {
    id
    created_at
    name
    room_id
    lc_id
    hc_id
    fc_id
    sms_conversation_id
    lc {
      ...GroupUser
    }
    hc {
      ...GroupUser
    }
    fc {
      ...GroupUser
    }
  }
  fragment GroupUser on users {
    user_id
    user_first_name
    user_last_name
    avatar: user_pic
    student_profiles {
      id
    }
  }
  fragment GroupStudent on group_students {
    id
    user_id
    user {
      ...GroupUser
    }
  }
`;

export const GET_GROUPS = gql`
  query getGroups {
    groups {
      ...Group
      users: group_users {
        ...GroupStudent
      }
    }
  }
  ${FRAGMENTS}
`;

export const GET_GROUP = gql`
  query getGroup($id: uuid!) {
    group: groups_by_pk(id: $id) {
      id
      name
    }
  }
`;

export const ADD_GROUP = gql`
  mutation addGroup($data: groups_insert_input!) {
    row: insert_groups_one(
      object: $data
      on_conflict: {
        constraint: groups_pkey
        update_columns: [sms_conversation_id]
      }
    ) {
      ...Group
    }
  }
  ${FRAGMENTS}
`;

export const ADD_STUDENT = gql`
  mutation addStudentToGroup(
    $groupId: uuid!
    $userId: Int!
    $hcId: Int!
    $lcId: Int!
    $convoId: uuid!
    $data: [chat_room_users_insert_input!]!
  ) {
    row: insert_group_students_one(
      object: { group_id: $groupId, user_id: $userId }
    ) {
      ...GroupStudent
    }
    update_student_profile(
      where: { user_id: { _eq: $userId } }
      _set: { hc_id: $hcId, lc_id: $lcId }
    ) {
      returning {
        id
        hc_id
        lc_id
      }
    }
    insert_conversation_users_one(
      object: { convo_id: $convoId, user_id: $userId }
    ) {
      convo_id
    }
    insert_chat_room_users(
      objects: $data
      on_conflict: {
        constraint: chat_room_users_room_id_user_id_key
        update_columns: [user_id]
      }
    ) {
      affected_rows
    }
  }
  ${FRAGMENTS}
`;

export const REMOVE_STUDENT = gql`
  mutation removeStudent(
    $id: Int!
    $roomId: Int!
    $userId: Int!
    $convoId: uuid!
  ) {
    delete_group_students_by_pk(id: $id) {
      id
    }
    delete_chat_room_users(
      where: { room_id: { _eq: $roomId }, user_id: { _eq: $userId } }
    ) {
      affected_rows
    }
    delete_conversation_users(
      where: { convo_id: { _eq: $convoId }, user_id: { _eq: $userId } }
    ) {
      affected_rows
    }
  }
`;

export const REMOVE_USER = gql`
  mutation removeStudent(
    $id: Int
    $roomId: Int!
    $userId: Int!
    $convoId: uuid
  ) {
    delete_chat_room_users(
      where: { room_id: { _eq: $roomId }, user_id: { _eq: $userId } }
    ) {
      affected_rows
    }
  }
`;

export const UPDATE_GROUP = gql`
  mutation updateGroup(
    $id: uuid!
    $data: groups_set_input!
    $upsertStudents: [student_profile_insert_input!]!
    $chatRoomData: [chat_room_users_insert_input!]!
  ) {
    groups: update_groups(where: { id: { _eq: $id } }, _set: $data) {
      returning {
        ...Group
      }
    }
    insert_student_profile(
      objects: $upsertStudents
      on_conflict: {
        constraint: student_profile_pkey
        update_columns: [lc_id, hc_id]
        where: { product_type: { _eq: "group" } }
      }
    ) {
      affected_rows
    }
    insert_chat_room_users(
      objects: $chatRoomData
      on_conflict: {
        constraint: chat_room_users_room_id_user_id_key
        update_columns: [user_id]
      }
    ) {
      affected_rows
    }
  }
  ${FRAGMENTS}
`;

export const DELETE_GROUP = gql`
  mutation deleteGroup($id: uuid!, $roomId: Int!) {
    delete_groups_by_pk(id: $id) {
      id
    }
    delete_chat_rooms_by_pk(id: $roomId) {
      id
    }
  }
`;

export const UPDATE_ROOM_ID = gql`
  mutation updateRoomID($id: uuid!, $data: groups_set_input!) {
    groups: update_groups(where: { id: { _eq: $id } }, _set: $data) {
      returning {
        ...Group
      }
    }
  }
  ${FRAGMENTS}
`;

export const GET_ADMIN_ID = gql`
  query getAdminId($studentId: Int!) {
    students: student_profile(where: { user_id: { _eq: $studentId } }) {
      admin_id
      lc_id
      hc_id
    }
  }
  ${FRAGMENTS}
`;
